/* eslint-disable no-unused-expressions */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { getUrl } from 'gatsby-core-theme/src/helpers/getters';
import { newsLetterForm } from 'gatsby-core-theme/src/constants/forms';

import Form from '../../../organisms/form';
import useTranslate from '~hooks/useTranslate/useTranslate';

const NewsletterForm = ({
  handleApi,
  submitText = 'Submit',
  market,
  path,
  country,
  showLabels = true,
  titleType = 'h2',
  buttonIcon = <FaArrowRight fontSize={20} title="Right-pointing Arrow Icon" />,
  page,
}) => {
  const [ip, setIP] = useState('');

  const getData = async () => {
    await fetch('https://api.ipify.org/?format=json', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setIP(data.ip);
      })
      .catch((err) => {
        console.log(`Error ${err}`);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  function removeTrailingSlash(url) {
    if (url.endsWith('/')) {
      return url.slice(0, -1);
    }
    return url;
  }

  const bacomApi = async (name, email, phomeNumber) => {
    // eslint-disable-next-line no-bitwise
    const timestamp = (Date.now() / 1000) | 0;
    const refUrl = removeTrailingSlash(process.env.GATSBY_SITE_URL);
    const validatePhoneNr = typeof phomeNumber === 'undefined';
    const refName = getUrl(path)?.replace('https://', '') || process.env.GATSBY_SITE_NAME;

    const response = await fetch(
      `https://subscribe.${
        process.env.GATSBY_SITE_NAME
      }/subscribe/leads/?firstname=${name}&user_ip=${ip}&ref_name=${refName}&ref_url=${refUrl}&timestamp=${timestamp}&country=${country}&email=${email}${
        !validatePhoneNr ? `&phone_number=${phomeNumber}` : ''
      }`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    );

    const text = await response.text();
    return text === 'OK';
  };
  const handelSubmit = (e) =>
    handleApi
      ? handleApi(e?.name?.value, e?.email?.value, e?.phomeNumber?.value, ip)
      : bacomApi(e?.name?.value, e?.email?.value, e?.phomeNumber?.value);

  const failMessage = useTranslate(
    'fail_error_newsletter',
    'Something went wrong. Please try again later!'
  );
  const successMessage = useTranslate('newsletter_form_thanks', '');

  return (
    <Form
      formOptions={newsLetterForm[market] || newsLetterForm.default}
      successMessage={successMessage}
      failMessage={failMessage}
      customeSubmit={handelSubmit}
      buttonLabel={submitText}
      path={path}
      showLabels={showLabels}
      titleType={titleType}
      buttonIcon={buttonIcon}
      page={page}
    />
  );
};
NewsletterForm.propTypes = {
  handleApi: PropTypes.func,
  submitText: PropTypes.string,
  market: PropTypes.string,
  path: PropTypes.string,
  country: PropTypes.string,
  showLabels: PropTypes.bool,
  titleType: PropTypes.string,
  buttonIcon: PropTypes.element,
  page: PropTypes.shape({}),
};

export default NewsletterForm;
